import React, {useEffect} from "react";
import { SET_WIDGET_ID, SWITCH_DISPLAY_PERIOD_MARKETS } from "../../store/spirs/actions";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {StoreType} from "../../store/spirs/types";
import {NavLink, useParams} from "react-router-dom";
import {SwitcherChildBlocks} from "../Line/SwitcherChildBlocks";
import clsx from "clsx";
import {TreeDirectory} from "../tree/Tree";
import styled from 'styled-components';
import { matchRouteParams, TREE_LIVE_TYPE } from '../../models/api/codegen/code';
import { makeSelectFilterTree } from '../VerticalMenu/selectors';


const Safari = styled.div`
  -webkit-overflow-scrolling: touch; /* Lets it scroll lazy */
`;

export const Live: React.FC = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        return () => {
            dispatch(SWITCH_DISPLAY_PERIOD_MARKETS(false));
        }
    }, []);

    return <Safari className='test'>
        <FullFixturesTree type={TREE_LIVE_TYPE.LIVE}/>
    </Safari>
};

export const LiveTop = () => <FullFixturesTree type={TREE_LIVE_TYPE.LIVE_RATING}/>;

export const LiveWidget = () => <FullFixturesTree type={TREE_LIVE_TYPE.LIVE_WIDGET}/>;

interface FullFixturesTreeProps {
    type: TREE_LIVE_TYPE
}

const FullFixturesTree = ({type}: FullFixturesTreeProps) => {
    const params = useParams<matchRouteParams>();
    const initSportId = params.sportId;
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const selectFilteredTree = React.useMemo(makeSelectFilterTree, []);
    const tree = useSelector((state: StoreType)=> selectFilteredTree(state, params));
    const [sportId, selectSportId] = React.useState<number | undefined>(initSportId ? Number(initSportId) : undefined);
    const [firstLoad, setFirstLoad] = React.useState(false);
    const [init, setInit] = React.useState(false);

    useEffect(() => {
        selectSportId(initSportId ? Number(initSportId) : undefined)
    }, [initSportId]);

    React.useEffect(() => {
        if (init && !firstLoad) {
            if (Object.keys(tree.fixtures).length > 0) {
                setFirstLoad(true);
                setInit(true)
                const first = Object.values(tree.fixtures)[0];
                // @ts-ignore
                type !== TREE_LIVE_TYPE.LIVE_WIDGET && dispatch(SET_WIDGET_ID({widgetId: first.fw, configurationId: first.wci}));
            }
        }
    }, [init, tree, firstLoad]);

    React.useEffect(() => {
        return () => {
            type !== TREE_LIVE_TYPE.LIVE_WIDGET && dispatch(SET_WIDGET_ID({widgetId: undefined}));
            dispatch(SWITCH_DISPLAY_PERIOD_MARKETS(false));
        }
    }, [])


    const navLinkClassNames = (condition: boolean) => clsx("text-[12px] tablet:text-[14px] mr-[15px] rounded-[8px] pl-[3px] pr-[3px] no-underline tablet:mt-[5px]", condition ? "text-white" : "text-[#ABABAB]");

    return (
        <>
            <div className="flex justify-between items-center bg-[#171A1E] rounded-[8px] pl-[16px] pr-[8px] mb-[8px] tablet:my-[16px] h-[24px] tablet:h-[48px] max-tablet:mx-[-16px]">
                <div className="flex items-center tablet:gap-[30px]">
                    <NavLink to={"/sport/live"} className={navLinkClassNames(type === TREE_LIVE_TYPE.LIVE)}>
                        {t("results.all.tabTitle")}
                    </NavLink>
                    <NavLink to={"/sport/live-top"} className={navLinkClassNames(type === TREE_LIVE_TYPE.LIVE_RATING)}>
                        {t("verticalMenuItems.Rating")}
                    </NavLink>
                    <NavLink to={"/sport/live-widget"} className={navLinkClassNames(type === TREE_LIVE_TYPE.LIVE_WIDGET)}>
                        {t("verticalMenuItems.Broadcast")}
                    </NavLink>
                </div>
                <div className="max-tablet:hidden">
                    <SwitcherChildBlocks/>
                </div>
            </div>
            {/*// @ts-ignore*/}
            <TreeDirectory sportId={sportId} tree={tree} mode={"LIVE"} fullHeight={false}/>
        </>
    );
}
